<button type="button" (click)="_open()">
    <i>G</i>
    <span>{{'Login com Google' | translate}}</span>
</button>    
<loader message="Logando. Aguarde!" *ngIf="loader"></loader>  